import type { ReactNode } from "react";
import { Page } from "@/components/Page";
import { SnapshotProvider } from "./snapshot.context";
import { SnapshotToasts } from "./SnapshotToasts";

interface SnapshotProps {
  /** The page itself: a SnapshotHeader and SnapshotContent. */
  children: ReactNode;
}

/**
 * A Snapshot page (order exports and 3PL stock reports): drop each report's files on its section
 * for the day picked; they upload straight to S3, and each section shows whether its snapshot is
 * built and up to date. A compound component; state is read with useSnapshot / useSnapshotSection.
 *
 *   <Snapshot>
 *     <SnapshotHeader title="Order snapshots">…</SnapshotHeader>
 *     <SnapshotContent>
 *       <SnapshotSection label="TheOrderExchange" report="toe" />
 *     </SnapshotContent>
 *   </Snapshot>
 */
export const Snapshot = (props: SnapshotProps) => {
  const { children } = props;

  return (
    <SnapshotProvider>
      <Page isLocked>{children}</Page>
      <SnapshotToasts />
    </SnapshotProvider>
  );
};
